<script setup lang="ts">
const isRedirectFromSafarmarket = computed(
    () => useLayoutStore().isRedirectFromSafarmarket
);
</script>

<template>
    <div v-show="isRedirectFromSafarmarket" class="sm-banner-container">
        <mr-blur-hash-image
            class="sm-image"
            src="/img/form/safarmarket.jpg"
            hash="L5Rlb6rD8w*J$jfQVXkC4Tf6yraK"
            :border-radius="8"
            ratio="1368:91"
            image-fit="contain"
        />
    </div>
</template>

<style lang="scss" scoped>
.sm-banner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    height: 60px;
    background-color: #ed6527;
}
.sm-image {
    align-self: center;
}
</style>
